import React from "react";
import { truncateDecimals } from "../CoC-Details/BenefitDetailTable/OtherBenefit";
import {
  overviewItem,
  itemLabel,
  itemValue,
  policyDetails,
  subTitle,
} from "../Shared/Styles";

// Date Format function
export const formatDate = (date) => {
  var d = new Date(date),
    day = "" + d.getDate(),
    month = "" + (d.getMonth() + 1),
    year = d.getFullYear();

  if (day.length < 2) day = "0" + day;
  if (month.length < 2) month = "0" + month;

  return [day, month, year].join("/");
};

export default function ProductDetails(props) {

  if (props.productDetails !== undefined) {
    return (
      <div>
        <h3 style={subTitle}>POLICY DETAILS</h3>

        <div style={policyDetails}>
          <div style={overviewItem}>
            <span style={itemLabel}>Product</span>
            <span style={itemValue}>{props.productDetails[0].productName}</span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Policy Ownership</span>
            <span style={itemValue}>{props.productDetails[0].policyOwner}</span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Payer</span>
            <span style={itemValue}>{props.productDetails[0].payer}</span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Payment Frequency</span>
            <span style={itemValue}>
              {props.productDetails[0].payFrequency}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Payment Method</span>
            <span style={itemValue}>
              {props.productDetails[0].paymentMethod}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Payment Details</span>
            <span style={itemValue}>
              {props.productDetails[0].paymentDetails}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Total Instalment Premium</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].sumInstallmentPremium, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Total Annual Premium</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].sumAnnualPremium, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Annual Policy Fee</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].annualPolicyFee, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Next Bill Date</span>
            <span style={itemValue}>
              {formatDate(props.productDetails[0].nextBillDate)}
            </span>
          </div>

          <div style={overviewItem}>
            <span style={itemLabel}>Arrears Amount</span>
            <span style={itemValue}>
              {truncateDecimals(props.productDetails[0].policyArrearAmount, 2).toLocaleString("en-US", {style: 'currency', currency: 'USD'})}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
